export default class Language {
    constructor() {

    }

    preValidateFormFields(id) {
        let translation = '';

        switch (id) {
            case 'gender':
            case 'geslacht':
            case 'state':
                translation = '%s nezvoleno';
                break;

            case 'firstname':
            case 'lastname':
            case 'voorletter':
            case 'achternaam':
                translation = '%s nemůže být prázdné';
                break;

            case 'street':
            case 'housenumber':
            case 'city':
            case 'address':
            case 'straat':
            case 'huisnummer':
            case 'plaats':
                translation = '%s pole je povinné';
                break;

            case 'telephone':
            case 'email':
            case 'heeltelefoonnummer':
            case 'mobile':
            case 'zipcode':
            case 'birthdate':
            case 'bankaccount':
                translation = '%s není správně vyplněné';
                break;

            case 'opt-in':
                translation = 'Než budete pokračovat, zaškrtněte toto pole';
                break;

            default:
                translation = 'Toto pole není správně vyplněné';
                break;
        }

        return translation;
    }

    /**
     * @link https://developers.google.com/maps/documentation/geocoding/intro?hl=nl#StatusCodes
     */
    addressMap(textType) {
        let translation = '';

        switch (textType) {
            case 'ZERO_RESULTS':
                translation = 'No results found';
                break;

            case 'address-not-checked':
                translation = 'Drag the map and drop the pin on the roof of your house';
                break;

            default:
                translation = 'An error has occured';
                break;
        }

        return translation;
    }
}
